module.exports = {"TXTCLI_No_data_available":{"id":"TXTCLI_No_data_available","defaultMessage":"Aucune donnée disponible"}}